import { useState } from "react";


import { FiSearch } from "react-icons/fi";
import AllAppointmentList from "../DoctorComponent.jsx/Tables/AllAppointmentList";
import AllPharmacyDetails from "./AllPharmacyDetails";
import { Network } from "lucide-react";
import { NetworkCellRounded } from "@mui/icons-material";

const PharmacyTabs = () => {    


  
  // ✅ Mock Appointment Data
  const appointmentData = [
  {
    id: 1,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
    productName:"Dolo 650mg",
    batchNo: "B12345",
   pack: "1's",
    date: "2025-08-20",
    mrp: "₹100(5% GST)",   
    purchaseRate: "₹90",
    netRate: "₹85(5% GST)",
    saleRate: "₹80(Mar: 22.06%)",
    stock: "50 packs(0 units)",
    status: "InStock",
  },
  {
    id: 2,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
    productName:"Amoxicillin",
    batchNo: "A67890",
    pack: "10's",
    date: "2025-08-18",
    mrp: "₹100(5% GST)",
   purchaseRate: "₹90",
    netRate: "₹85(5% GST)",
    saleRate: "₹80(Mar: 20.06%)",
    stock: "20 packs(0 units)",
    status: "LowStock",
  },
  {
    id: 3,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
     productName:"Amoxicillin",
    batchNo: "I54321",
   pack: "5's",
    date: "2025-08-10",
    mrp: "₹110(5% GST)",
   purchaseRate: "₹90",
    netRate: "₹85(5% GST)",
    saleRate: "₹90(Mar: 25.06%)",
    stock: "Out of Stock",
    status: "OutOfStock",
  },
  {
    id: 4,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
    productName:"Azithromycin",
    batchNo: "C98765",
pack: "2's",
    date: "2025-08-25",
    mrp: "₹120(5% GST)",
    purchaseRate: "₹100",
    netRate: "₹95(5% GST)",
    saleRate: "₹90(Mar: 18.06%)",
    stock: "80 packs",
    status: "InStock",
  },
  {
    id: 5,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
 productName:"Azithromycin",
    batchNo: "M11223",
    pack: "15's",
    date: "2025-08-22",
    mrp: "₹250(5% GST)", 
    purchaseRate: "₹220",
    netRate: "₹210(5% GST)",  
    saleRate: "₹200(Mar: 12.06%)",  
    stock: "30 packs",
    status: "InStock",
  },
  {
    id: 6,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
  productName:"Amlodipine",
    batchNo: "A44556",
    pack: "20's",
    date: "2025-09-01",
    mrp: "₹180(5% GST)",  
    purchaseRate: "₹160",
    netRate: "₹155(5% GST)",  
    saleRate: "₹150(Mar: 15.06%)",
    stock: "40 packs",
    status: "InStock",
  },
  {
    id: 7,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
  productName:"Amlodipine",
    batchNo: "T77889",
    pack: "8's",
    date: "2025-09-05",
    mrp: "₹220(5% GST)",
    purchaseRate: "₹200",
    netRate: "₹190(5% GST)",
    saleRate: "₹180(Mar: 10.06%)",     
    stock: "25 packs",
    status: "LowStock",   
    
  },
    {
    id: 8,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
  productName:"Ibuprofen",
    batchNo: "L33445",
    pack: "12's",
    date: "2025-09-10",
    mrp: "₹130(5% GST)",
   purchaseRate: "₹110",
    netRate: "₹105(5% GST)", 
    saleRate: "₹100(Mar: 22.06%)",
    stock: "60 packs",
    status: "InStock",  
   
  },
  {
    id: 9,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
   productName:"Ibuprofen",
    batchNo: "O55667",
    pack: "25's",  
    date: "2025-09-15",
    mrp: "₹300(5% GST)",
    purchaseRate: "₹270",
    netRate: "₹260(5% GST)",    
    saleRate: "₹250(Mar: 8.06%)",     
    stock: "35 packs",
    status: "InStock",  
  },
  {
    id: 10,
    itemImage: "https://onemg.gumlet.io/l_watermark_346,w_380,h_380/a_ignore,w_380,h_380,c_fit,q_auto,f_auto/b107edeb006c415e8d242f1f57e9e35b.jpg",
     productName:"Cheston Cold",
    batchNo: "A88990",
pack: "30's",   

    date: "2025-09-20",
    mrp: "₹280(5% GST)", 
    purchaseRate: "₹250",
    netRate: "₹240(5% GST)",   
    saleRate: "₹230(Mar:5.06%)",     
    stock: "45 packs",
    status: "InStock",  
  },
]; 


  return (
    <div className="space-y-4 h-full">
      {/* Tab Content */}
      <div className="p-2 border rounded-lg bg-white shadow-sm h-[90%] mt-3">
          <AllPharmacyDetails data={appointmentData} />
        
          

       
      </div>
    </div>
  );
};

export default PharmacyTabs;